import React from 'react';
import { useFiltersContext } from '@/creditflowresearch/application/FiltersContext';
import BaseSearchInput from '@/creditflowresearch/ui/common/components/molecules/SearchInput';
import { useTraceTableContext } from '@/creditflowresearch/application/Trace/TraceTableContext';
import useGetTracePayload from '@/creditflowresearch/application/Trace/useGetTracePayload';

const SearchInput = (props) => {
  const config = {
    name: 'searchTrades',
    placeholder: 'Filter by Bond, Issuer or CUSIP',
  };
  const {
    onSearch,
    params: { search },
  } = useFiltersContext();
  const { debouncedGetTrades } = useTraceTableContext();
  const { getPayload } = useGetTracePayload();

  const onChange = ({ target: { value } }) => {
    onSearch(value);
    debouncedGetTrades(getPayload({
      params: {
        search: value,
        page: 1,
      },
    }));
  };

  return (
    <BaseSearchInput
      { ...props }
      { ...config }
      value={ search }
      onChange={ onChange }
      dataTest="formSearchInput"
    />
  );
};

export default SearchInput;
